import { AfterViewInit, Directive, ElementRef } from '@angular/core';
import { TooltipDirective } from 'ngx-bootstrap/tooltip';

@Directive({
    selector: '[appShowIfTruncated]',
    standalone: false
})
export class ShowIfTruncatedDirective implements AfterViewInit {

  constructor(
    private _elementRef: ElementRef<HTMLElement>,
    private _tooltipDir: TooltipDirective
  ) { }

  ngAfterViewInit(): void {
    this.setTooltipState();
  }

  setTooltipState(): void {
    const element = this._elementRef.nativeElement;
    const result: boolean = !(element.offsetWidth < element.scrollWidth);
    this._tooltipDir.isDisabled = result;
  }

}
